const sigin = {
  en: {
    title: "Sign in to your account",
    forgot_my_password: "Forgot my password",
    user_email: "Email",
    insert_user_email: "Insert Email",
    password: "Password",
    insert_password: "Insert Password",
    access: "Access"
  },
  pt: {
    title: "Inicie a sessão na sua conta",
    forgot_my_password: "Esqueci minha senha",
    user_email: "Email",
    insert_user_email: "Digite o Email",
    password: "Senha",
    insert_password: "Digite a senha",
    access: "Acessar"
  },
  es: {
    title: "Inicie sesión en su cuenta",
    forgot_my_password: "He olvidado mi contraseña",
    user_email: "Correo electrónico",
    insert_user_email: "Insertar correo electrónico",
    password: "Contraseña",
    insert_password: "Insertar contraseña",
    access: "Acceda a"
  }
}

export default sigin
